/**
 * Volunteering data
 */

export const volunteeringData = [
  {
    id: 1,
    image: require('../images/company/citi.jpg'),
    imageAlt: 'Citi',
    title: '2024 London Tech Grads Rep',
    subtitle: 'Imperial College London',
    date: 'Sept 2024 - Present',
    description: 'Represented the year groups, organised socials, talks from senior speaker series, ',
  },
  {
    id: 1,
    image: require('../images/company/citi.jpg'),
    imageAlt: 'Citi',
    title: 'Budy Scheme',
    subtitle: 'Imperial College London',
    date: 'Sept 2024 - Present',
    description: 'Helped the new 2025 grads settle into Citi and help them with navigating common issues first years face in the bank.',
  },
  {
    id: 2,
    image: require('../images/company/ie.jpg'),
    imageAlt: 'Imperial College London logo',
    title: 'Yearbook',
    subtitle: 'Imperial College London',
    date: 'Apr 2022 - July 2024',
    description: 'EE yearbook comitee<br />Helped create a yearbook for the entire yearbook with no funding and during exams and final year project term.',
  },
  {
    id: 3,
    image: require('../images/company/imperial_logo.jpg'),
    imageAlt: 'Imperial College London logo',
    title: 'EIE Academic Rep',
    subtitle: 'Imperial College London',
    date: 'Oct 2022 - June 2024',
    description: 'Electrical Engineering<br />Raised student concerns to the department and helped improve the student experience.',
  },
  {
    id: 4,
    image: require('../images/company/ie.jpg'),
    imageAlt: 'Imperial College London logo',
    title: 'Mums and Dads Scheme',
    subtitle: 'Imperial College London',
    date: 'Oct 2022 - June 2024',
    description: 'Imperial EESoc<br />Helped new 1st-year students settle into University and guided them with any questions and concerns they had.',
  },
  {
    id: 5,
    image: require('../images/company/paksoc.jpg'),
    imageAlt: 'Imperial College London logo',
    title: 'Mums and Dads Scheme',
    subtitle: 'Imperial College London',
    date: 'Oct 2021 - Jun 2022',
    description: 'Imperial Paksoc<br />Helped new 1st-year students settle into University and guided them with any questions and concerns they had.',
  },
  {
    id: 6,
    image: require('../images/company/newham.jpg'),
    imageAlt: 'Newham logo',
    title: 'Keyboardist',
    subtitle: 'Katherine Road Community Centre',
    date: 'Jan 2016 - Dec 2017',
    description: 'I performed for the residents of a community during their community events and ensured that a positive atmosphere remained throughout the day.',
  },
];

